import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { Tournament, TournamentPrizes } from 'src/app/services/tournaments/tournaments.models';
import { BasePageComponent } from '../../base-page/base-page.component';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-tournament-prizes',
  templateUrl: './tournament-prizes.component.html',
  styleUrls: ['./tournament-prizes.component.scss']
})
export class TournamentPrizesComponent extends BasePageComponent {

  constructor(
    protected tournamentDetails: TournamentDetailsService,
    protected licenceService: LicenceService
  ) { super() }

  @Input() tournament: Tournament;
  prizes: TournamentPrizes[];

  getDetails() {
    this.tournamentDetails.getTournamentPrizes(this.tournament.cmsId).pipe(
      takeUntil(this.unsubscribe)
    ).subscribe((prizes) => {
      this.prizes = prizes;
      console.log('prizes', this.prizes)
    })
  }

  ngOnInit(): void {
    this.getDetails();
  }

}
